<template>
    <div class="tree-item">
        <div class="tree-item-title">
            {{ pageData.name }}
        </div>
        <v-select-list
            v-model="bo"
            :options="getSelectList"
            @select="getSelected"
        >
            <template
                slot="item"
                slot-scope="props"
            >
                <div class="tree-item-content">
                    {{ props.item.text + '(' + props.item.count + ')' }}
                </div>
            </template>
        </v-select-list>
    </div>
</template>
<script>
export default {
  props: {
    pageData: {
      type: Object,
      default: () => {},
    },
    bo: {
      type: Number,
      default: 50,
    },
  },
  computed: {
    getSelectList() {
      const arr = this.pageData.bos.map((val) => {
        const obj = {};
        obj.text = val.name;
        obj.value = val.id;
        obj.count = val.count;
        return obj;
      });
      return arr;
    },
  },
  methods: {
    getSelected(data) {
      this.$emit('getSeletedBo', data);
    },
  },
};
</script>
<style lang="less" scoped>
.tree-item {
    width: 238px;

    &-title {
        padding-left: 12px;

        font-size: 12px;
        color: #66686c;
        line-height: 30px;
        background: #f8fafb;
    }
    &-content {
        padding-left: 24px;

        font-size: 14px;
        color: #1e2330;
        line-height: 48px;

        cursor: pointer;

        // :hover {
        //     background: #0067ED;
        // }
    }
}
</style>
